module.exports = {"name":"Tlačidlo na vytvorenie novej tézy","icon":"<i class='material-icons'>edit</i>","widget":{"type":"athesis-create-button","initData":{"title":"Vytvoriť novú tézu"}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/thesis-create-button/thesis-create-button.json
// module id = 398
// module chunks = 0